import React, { useState } from "react";
import axios from "axios";
import logo from "../../assets/logo.png";
import { useUser } from "../../UserContext";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import toast from "react-hot-toast";
import { Eye, EyeOff } from "lucide-react";

const Login = ({ expanded, setIsLoggedIn }) => {
  const { login } = useUser();
  const navigate = useNavigate();
  const [studentNumber, setStudentNumber] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);

    try {
      const response = await axios.post(
        "https://class-trackr-server.onrender.com/login",
        {
          studentNumber: studentNumber.trim(),
          password: password.trim(),
        }
      );

      if (response.status === 200) {
        sessionStorage.setItem(
          "user",
          JSON.stringify({
            studentNumber: studentNumber.trim(),
            name: response.data.name,
            section: response.data.section,
            admin: response.data.admin,
          })
        );
        login(
          studentNumber.trim(),
          response.data.name,
          response.data.section,
          response.data.admin
        );

        setIsLoggedIn(true);
        navigate("/class/0");
      } else {
        console.error("Login failed");
        toast.error("Wrong student number or password. Please try again!");
        // Handle login failure, display error message, etc.
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Wrong student number or password. Please try again!");
      // Handle network errors or other issues
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <section className="bg-gray-50">
        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto h-[80vh] lg:py-0">
          <div className="flex items-center mb-4 text-2xl font-semibold text-gray-900 ">
            <img className="w-44" src={logo} alt="logo" />
          </div>
          <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0">
            <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
              <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl ">
                Sign in to your account
              </h1>
              <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
                <div>
                  <label
                    htmlFor="studentNumber"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Student Number or Email
                  </label>
                  <input
                    type="text"
                    name="studentNumber"
                    id="studentNumber"
                    className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                    placeholder="Student Number or Email"
                    value={studentNumber}
                    onChange={(e) => setStudentNumber(e.target.value)}
                    required
                  />
                </div>
                <div>
                  <label
                    htmlFor="password"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Password
                  </label>
                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      id="password"
                      placeholder="••••••••"
                      className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 pr-10"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <button
                      type="button"
                      className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-600 focus:outline-none"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <EyeOff size={22} /> : <Eye size={22} />}
                    </button>
                  </div>
                </div>
                {loading ? ( // Conditionally render loading spinner
                  <div className="flex items-center justify-center">
                    <ClipLoader color={"#198754"} loading={loading} size={35} />
                  </div>
                ) : (
                  <button
                    type="submit"
                    className="w-full text-white bg-[#198754] hover:bg-green-600 focus:ring-4 focus:ring-green-300 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                  >
                    Sign in
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Login;
